import {useEffect} from 'react';

export default function useOnCountrySelectionChange(
  previouslySelectedCountryCode,
  selectedCountryCode,
  onChangeFn,
) {

  useEffect(
    ()=> {
      if (selectedCountryCode !== previouslySelectedCountryCode) {
        onChangeFn();
      }
    },
    [
      previouslySelectedCountryCode,
      selectedCountryCode,
      onChangeFn
    ]
  )
}
